module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_7042.02f10980.png";